<template>
  <div class="es-add-item-container">
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#0f172a"
      spinner="bar-fade-scale"
    />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showsnackbar" color="#1e293b" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: white">
            {{ msg }}
          </span>
        </v-flex>

        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: #fff">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>

    <v-card flat class="estimate-item-card mb-4 rounded-lg">
      <div class="card-top-bar px-4 py-3 d-flex align-center justify-space-between">
        <div class="d-flex align-center">
          <v-icon small color="#475569" class="mr-2">mdi-layers-outline</v-icon>
          <span class="card-heading">Add Item Details</span>
        </div>
      </div>
      <v-divider></v-divider>

      <div class="pa-4">
        <!-- Row 1: Item, Design, Supplier & Qty -->
        <div class="item-selection-grid mb-3">
          <div class="grid-item">
            <label class="erp-field-label">Item <span class="required-star">*</span></label>
            <v-autocomplete
              outlined
              dense
              color="#9a6b27"
              hide-details
              class="erp-field"
              v-model="purchaseItem.ItemCode"
              :items="ItemList"
              placeholder="Select an Item"
              item-value="_id"
              item-text="name"
              :filter="customFilter"
              @input="getDesign()"
            >
              <template slot="selection" slot-scope="data">
                <span class="selected-text">{{ data.item.name }} - {{ data.item.code }}</span>
              </template>
              <template slot="item" slot-scope="data">
                <v-list-item-content>
                  <v-list-item-title>{{ data.item.name }} - {{ data.item.code }}</v-list-item-title>
                </v-list-item-content>
              </template>
            </v-autocomplete>
          </div>

          <div class="grid-item">
            <label class="erp-field-label">Design <span class="required-star">*</span></label>
            <v-autocomplete
              color="#9a6b27"
              :items="designList"
              v-model="purchaseItem.design"
              return-object
              placeholder="Select Design"
              item-text="_id.design.name"
              item-value="_id.id"
              outlined
              dense
              hide-details
              class="erp-field"
              @input="getSupplier(), checktype(purchaseItem.design._id)"
            >
              <template slot="selection" slot-scope="data">
                <span class="selected-text" :title="designOptionLabel(data.item)">{{ designOptionLabel(data.item) }}</span>
              </template>
              <template slot="item" slot-scope="data">
                <v-list-item-content>
                  <v-list-item-title>{{ designOptionLabel(data.item) }}</v-list-item-title>
                </v-list-item-content>
              </template>
            </v-autocomplete>
          </div>

          <div class="grid-item" :class="{ 'grid-item-supplier-wide': dtype != true }">
            <label class="erp-field-label">Supplier <span class="required-star">*</span></label>
            <v-autocomplete
              :items="SupplierList"
              v-model="purchaseItem.supplierCode"
              placeholder="Select supplier"
              item-text="supplierName"
              item-value="_id"
              outlined
              dense
              hide-details
              class="erp-field"
              @input="checkQty(), getPurchase()"
              color="#9a6b27"
            ></v-autocomplete>
          </div>

          <div class="grid-item" v-if="dtype == true">
            <label class="erp-field-label">Quantity</label>
            <v-text-field
              v-model="purchaseItem.quantity"
              outlined
              dense
              hide-details="auto"
              class="erp-field"
              @input="cal3()"
              type="number"
              :hint="stockCount"
              :rules="[maxValueRule2(stockcount1),(val) => val >= 0 || 'Value must be >= 0']"
              color="#9a6b27"
              placeholder="Qty"
            ></v-text-field>
          </div>
        </div>

        <!-- Row 2: Metal Type, VA, Rates, Net Wt, Charges, Discount, Total & Action Button -->
        <div class="item-calculation-grid" :class="{ 'has-charge-type': newMetalType === 'Silver' }">
          <div class="grid-item">
            <label class="erp-field-label">Metal</label>
            <v-select
              v-model="newMetalType"
              :items="['Gold', 'Silver', 'Diamond']"
              outlined
              dense
              hide-details
              class="erp-field"
              color="#9a6b27"
              placeholder="Metal"
            ></v-select>
          </div>

          <div class="grid-item" v-if="newMetalType === 'Silver'">
            <label class="erp-field-label">Charge Type</label>
            <v-select
              v-model="newMakingChargeType"
              :items="['Percentage', 'Flat']"
              outlined
              dense
              hide-details
              class="erp-field"
              color="#9a6b27"
            ></v-select>
          </div>

          <div class="grid-item">
            <label class="erp-field-label">VA (%)</label>
            <v-text-field
              v-model="purchaseItem.va"
              outlined
              dense
              hide-details="auto"
              class="erp-field"
              type="number"
              :rules="[maxValueRule]"
              :disabled="newMetalType === 'Silver' && newMakingChargeType === 'Flat'"
              @input="cal1()"
              color="#9a6b27"
              placeholder="0.0"
            ></v-text-field>
          </div>

          <div class="grid-item">
            <label class="erp-field-label">Rate (₹)</label>
            <v-text-field
              @input="cal1()"
              type="number"
              :disabled="itempresent == true ? true : false"
              v-model="purchaseItem.boardingRate"
              outlined
              dense
              hide-details
              class="erp-field"
              color="#9a6b27"
              placeholder="Rate"
            ></v-text-field>
          </div>

          <div class="grid-item">
            <label class="erp-field-label">Net Wt (gm)</label>
            <v-text-field
              v-if="dtype == true"
              disabled
              type="number"
              v-model="purchaseItem.netweight"
              outlined
              dense
              hide-details="auto"
              class="erp-field erp-readonly"
              color="#9a6b27"
              placeholder="0.000"
              @input="cal1()"
            ></v-text-field>
            <v-text-field
              v-else
              v-model="purchaseItem.netweight"
              outlined
              dense
              hide-details="auto"
              class="erp-field"
              :hint="totNetWeight"
              type="number"
              :rules="[maxValueRule3(totNetWeight1),(val) => val >= 0 || 'Value must be > 0']"
              @input="cal1()"
              color="#9a6b27"
              placeholder="0.000"
            ></v-text-field>
          </div>

          <div class="grid-item">
            <label class="erp-field-label">Making Chg (₹)</label>
            <v-text-field
              v-model="purchaseItem.makingCharge"
              outlined
              dense
              hide-details
              class="erp-field"
              type="number"
              color="#9a6b27"
              placeholder="0.00"
              :disabled="!(newMetalType === 'Silver' && newMakingChargeType === 'Flat')"
              @input="cal2()"
            ></v-text-field>
          </div>

          <div class="grid-item">
            <label class="erp-field-label">Discount (₹)</label>
            <v-text-field
              v-model="purchaseItem.discount"
              outlined
              dense
              hide-details
              class="erp-field"
              type="number"
              color="#9a6b27"
              placeholder="0.00"
              @input="cal2()"
            ></v-text-field>
          </div>

          <div class="grid-item">
            <label class="erp-field-label">Total (₹)</label>
            <v-text-field
              v-model="purchaseItem.itemTotalAmount"
              outlined
              dense
              hide-details
              class="erp-field erp-readonly font-weight-bold"
              disabled
              color="#9a6b27"
              placeholder="0.00"
            ></v-text-field>
          </div>

          <div class="grid-action-item">
            <label class="erp-field-label action-label-placeholder" aria-hidden="true">&nbsp;</label>
            <v-btn
              @click="validate()"
              dark
              class="erp-add-item-btn"
              title="Add Item to Estimate"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </div>
        </div>
      </div>

      <!---------------------Table-------------------------->
      <div class="px-4 pb-4" v-if="List && List.length > 0">
        <v-card outlined class="rounded-lg overflow-hidden erp-table-card">
          <v-simple-table dense class="erp-item-table m-stack-table m-stack-grid">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">#</th>
                  <th class="text-left">Item Details</th>
                  <th class="text-left">HSN</th>
                  <th class="text-right">Qty</th>
                  <th class="text-right">Gr. Wt (gm)</th>
                  <th class="text-right">St. Wt (gm)</th>
                  <th class="text-right">Net Wt (gm)</th>
                  <th class="text-right">Mk. Chg (₹)</th>
                  <th class="text-right">VA (%)</th>
                  <th class="text-right">Discount (₹)</th>
                  <th class="text-right">CGST (%)</th>
                  <th class="text-right">SGST (%)</th>
                  <th class="text-right">Total (₹)</th>
                  <th class="text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(value, i) in List" :key="i" class="table-row-hover">
                  <td data-label="#">{{ i + 1 }}</td>
                  <td data-label="Item Details" class="font-weight-medium">
                    <span v-if="value.designId">{{ value.designId.name }} - {{ value.itemId.name }}</span>
                    <span v-else>-</span>
                  </td>
                  <td data-label="HSN">
                    <span v-if="value.designId && value.designId.HSN">{{ value.designId.HSN.hsnCode }}</span>
                    <span v-else>-</span>
                  </td>
                  <td data-label="Qty" class="text-right">{{ value.quantity || '-' }}</td>
                  <td data-label="Gr. Wt (gm)" class="text-right">{{ (value.grossWeight || 0).toFixed(2) }}</td>
                  <td data-label="St. Wt (gm)" class="text-right">{{ (value.stoneWeight || 0).toFixed(2) }}</td>
                  <td data-label="Net Wt (gm)" class="text-right font-weight-medium">{{ (value.netWeight || 0).toFixed(2) }}</td>
                  <td data-label="Mk. Chg (₹)" class="text-right">
                    {{ value.discountAmount ? (value.adjustedMakingCharge).toFixed(2) : (value.makingCharge ? value.makingCharge.toFixed(2) : '0.00') }}
                  </td>
                  <td data-label="VA (%)" class="text-right">
                    {{ value.valueAddition ? value.valueAddition.toFixed(2) : '0.00' }}
                  </td>
                  <td data-label="Discount (₹)" class="text-right">{{ value.discountAmount ? value.discountAmount.toFixed(2) : '0.00' }}</td>
                  <td data-label="CGST (%)" class="text-right">{{ value.cgst ? value.cgst.toFixed(2) : '0.00' }}</td>
                  <td data-label="SGST (%)" class="text-right">{{ value.sgst ? value.sgst.toFixed(2) : '0.00' }}</td>
                  <td data-label="Total (₹)" class="text-right font-weight-bold">{{ value.amountWithGst ? value.amountWithGst.toFixed(2) : '0.00' }}</td>
                  <td data-label="Actions" class="text-center">
                    <v-btn
                      icon
                      x-small
                      class="mr-1"
                      color="#475569"
                      title="Edit Item"
                      @click="
                        (curitem = value),
                        (curitem.stonePerPiece = value.quantity > 0 ? (value.stoneWeight || 0) / value.quantity : 0),
                        (tstcat = value.designId),
                        (tsttype = (value.purchaseItemId && value.purchaseItemId.countOrSplit) || value.designId.countOrSplit),
                        (editdialogue = true),
                        getItem()
                      "
                    >
                      <v-icon small>mdi-pencil-outline</v-icon>
                    </v-btn>
                    <v-btn
                      icon
                      x-small
                      color="#dc2626"
                      title="Remove Item"
                      @click="(dialoge = true), (curId = value._id)"
                    >
                      <v-icon small>mdi-delete-outline</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>

          <!-- Table Summary Footer Bar -->
          <div class="table-summary-bar px-4 py-3 d-flex justify-end align-center flex-wrap" v-if="saledata">
            <div class="summary-pill mr-3" v-if="saledata.totalNetWeight">
              <span class="pill-label">Total Weight:</span>
              <span class="pill-val font-weight-bold">{{ saledata.totalNetWeight.toFixed(2) }} gm</span>
            </div>
            <div class="summary-pill highlight-pill" v-if="saledata.totalAmountWithGst || saledata.totalAmountWithoutGst">
              <span class="pill-label">Total Sale Amount:</span>
              <span class="pill-val font-weight-bold">
                ₹ {{ (billType=='GST' || taxType=='true') ? (saledata.totalAmountWithGst ? saledata.totalAmountWithGst.toFixed(2) : '0.00') : (saledata.totalAmountWithoutGst ? saledata.totalAmountWithoutGst.toFixed(2) : '0.00') }}
              </span>
            </div>
          </div>
        </v-card>
      </div>
    </v-card>

    <!-- Delete Confirmation Modal -->
    <v-dialog width="420px" v-model="dialoge">
      <v-card class="rounded-lg erp-modal-card">
        <div class="modal-top-bar px-5 py-4 d-flex align-center justify-space-between">
          <div class="d-flex align-center">
            <v-icon color="#dc2626" class="mr-2">mdi-alert-circle-outline</v-icon>
            <span class="modal-title">Remove Item</span>
          </div>
          <v-btn icon small @click="dialoge = false">
            <v-icon color="#64748b">mdi-close</v-icon>
          </v-btn>
        </div>
        <v-divider></v-divider>
        <div class="pa-5 font-weight-regular" style="color: #334155; font-size: 14px;">
          Are you sure you want to remove this item from the estimate? This action cannot be undone.
        </div>
        <v-divider></v-divider>
        <div class="px-5 py-3 d-flex justify-end align-center bg-modal-footer">
          <v-btn text color="#64748b" class="mr-2 text-capitalize" @click="dialoge = false">Cancel</v-btn>
          <v-btn color="#dc2626" dark class="text-capitalize px-4 rounded-lg" @click="deleteStaff()">
            <v-icon left small>mdi-delete</v-icon>
            Remove Item
          </v-btn>
        </div>
      </v-card>
    </v-dialog>

    <!-- Edit Item Modal -->
    <v-dialog width="680px" v-model="editdialogue">
      <v-card class="rounded-lg erp-modal-card">
        <div class="modal-top-bar px-5 py-4 d-flex align-center justify-space-between">
          <div class="d-flex align-center">
            <v-icon color="#0f172a" class="mr-2">mdi-pencil-outline</v-icon>
            <div>
              <div class="modal-title">Edit Item Details</div>
              <div class="modal-subtext">Update quantity, making charges or discounts</div>
            </div>
          </div>
          <v-btn icon small @click="editdialogue = false">
            <v-icon color="#64748b">mdi-close</v-icon>
          </v-btn>
        </div>
        <v-divider></v-divider>
        <div class="pa-5">
          <v-row dense>
            <v-col cols="12" sm="4" class="py-1" v-if="curitem.designId">
              <div v-if="((curitem.purchaseItemId && curitem.purchaseItemId.countOrSplit) || curitem.designId.countOrSplit)=='Count'">
                <label class="erp-field-label">Quantity</label>
                <v-text-field
                  v-model="curitem.quantity"
                  outlined
                  dense
                  type="number"
                  :rules="[maxValueRule4(curitem.purchaseItemId.count)]"
                  color="#9a6b27"
                  @input="caledit1()"
                  placeholder="Quantity"
                  hide-details="auto"
                  class="erp-field"
                ></v-text-field>
              </div>
              <div v-else>
                <label class="erp-field-label">Quantity</label>
                <v-text-field
                  outlined
                  disabled
                  type="number"
                  placeholder="0"
                  dense
                  hide-details
                  class="erp-field erp-readonly"
                ></v-text-field>
              </div>
            </v-col>

            <v-col cols="12" sm="4" class="py-1">
              <label class="erp-field-label">Metal Type</label>
              <v-select
                v-model="curMetalType"
                :items="['Gold', 'Silver', 'Diamond']"
                outlined
                dense
                color="#9a6b27"
                hide-details
                class="erp-field"
              ></v-select>
            </v-col>

            <v-col cols="12" sm="4" class="py-1" v-if="curMetalType === 'Silver'">
              <label class="erp-field-label">Making Charge Type</label>
              <v-select
                v-model="curMakingChargeType"
                :items="['Percentage', 'Flat']"
                outlined
                dense
                color="#9a6b27"
                hide-details
                class="erp-field"
              ></v-select>
            </v-col>

            <v-col cols="12" sm="4" class="py-1">
              <label class="erp-field-label">VA (%)</label>
              <v-text-field
                v-model="curitem.valueAddition"
                outlined
                dense
                type="number"
                :disabled="curMetalType === 'Silver' && curMakingChargeType === 'Flat'"
                @input="editcal1()"
                color="#9a6b27"
                hide-details
                class="erp-field"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="4" class="py-1">
              <label class="erp-field-label">Boarding Rate (₹)</label>
              <v-text-field
                disabled
                type="number"
                v-model="curitem.goldRate"
                outlined
                dense
                hide-details
                class="erp-field erp-readonly"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="4" class="py-1">
              <label class="erp-field-label">Net Wt (gm)</label>
              <v-text-field
                v-model="curitem.netWeight"
                outlined
                dense
                :disabled="tsttype=='Count'?true:false"
                type="number"
                @input="editcal1()"
                color="#9a6b27"
                hide-details
                class="erp-field"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="4" class="py-1">
              <label class="erp-field-label">Making Charge (₹)</label>
              <v-text-field
                v-model="curitem.makingCharge"
                outlined
                dense
                type="number"
                color="#9a6b27"
                :disabled="!(curMetalType === 'Silver' && curMakingChargeType === 'Flat')"
                hide-details
                class="erp-field"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="4" class="py-1">
              <label class="erp-field-label">Discount (₹)</label>
              <v-text-field
                v-model="curitem.discountAmount"
                outlined
                dense
                type="number"
                color="#9a6b27"
                hide-details
                class="erp-field"
              ></v-text-field>
            </v-col>
          </v-row>
        </div>
        <v-divider></v-divider>
        <div class="px-5 py-3 d-flex justify-end align-center bg-modal-footer">
          <v-btn text color="#64748b" class="mr-2 text-capitalize" @click="editdialogue = false">Cancel</v-btn>
          <v-btn dark class="erp-action-btn text-capitalize px-5" @click="editcal2()">
            <v-icon left small>mdi-check</v-icon>
            Update Item
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: ["title", "datareload", "customerName", "contact"],
  data() {
    return {
      quotation: "1",
      appLoading: false,
      ServerError: false,
      showsnackbar: false,
      timeout: 2000,
      msg: null,
      estno: null,
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      juwellaryId: localStorage.getItem("juwellaryId"),
      itemz: [],
      designList: [],
      designList2: [],
      SupplierList: [],
      purchaseItem: {
        ItemCode: null,
        supplierCode: null,
        design: null,
        quantity: "",
        va: "",
    // taxType: localStorage.getItem("GSTstatus"),
        // boardingRate: localStorage.getItem("goldRate"),
        boardingRate: "",

        makingCharge: "",
        netweight: "",
        discount: "",
        newVA: "",
        newmakingcharge: "",
        itemTotalAmount: "",
        purchaseId: "",
        purchaseitemId: "",
        amountWithoutGst:"",
        amountWithGst:"",
      },
      singleitem: {
        itemId: null,
        supplierId: null,
        designId: null,
        quantity: "",
        valueAddition: "",
        goldRate: "",
        makingCharge: "",
        netWeight: "",
        discountAmount: "",
        adjustedMakingCharge: "",
        adjustedVA: "",
        itemTotalAmount: "",
        purchaseId: "",
        purchaseitemId: "",
        amountWithoutGst:"",
        amountWithGst:"",
      },
      List: [],
      saledata: [],
      ItemList: [],
      dtype: false,
      curitem: {},
      selectedItemWt: 0,
      itemz2: [],
      purchaseList: [],
      weightList: [],
      editdialogue: false,
      curId: null,
      dialoge: false,
      total3: "",
      stockCount: "",
      itempresent: false,
      stst1: false,
      stst2: false,
      itemPerWeight: 0,
      totNetWeight: "",
      gstpercent:0,
      billType:"DEMO",
      stockcount1:"",
      totNetWeight1:"",
      tsttype:"",
      savedgrate:"",
    };
  },
  computed: {
    taxType() {
      return localStorage.getItem("GSTstatus");
    },
    goldRate1() {
      return localStorage.getItem("goldRate");
    },
    curMetalType: {
      get() {
        return this.curitem.metalType || "Gold";
      },
      set(val) {
        this.$set(this.curitem, "metalType", val);
        if (val !== "Silver") {
          this.$set(this.curitem, "makingChargeType", "Percentage");
        }
        this.editcal1();
      },
    },
    curMakingChargeType: {
      get() {
        return this.curitem.makingChargeType || "Percentage";
      },
      set(val) {
        this.$set(this.curitem, "makingChargeType", val);
        if (val !== "Flat") {
          this.editcal1();
        }
      },
    },
    newMetalType: {
      get() {
        return this.purchaseItem.metalType || "Gold";
      },
      set(val) {
        this.$set(this.purchaseItem, "metalType", val);
        if (val !== "Silver") {
          this.$set(this.purchaseItem, "makingChargeType", "Percentage");
        }
        this.cal1();
      },
    },
    newMakingChargeType: {
      get() {
        return this.purchaseItem.makingChargeType || "Percentage";
      },
      set(val) {
        this.$set(this.purchaseItem, "makingChargeType", val);
        if (val !== "Flat") {
          this.cal1();
        }
      },
    },
  },
  mounted() {
    this.getItem();
    if(this.List.length>0){
      this.purchaseItem.boardingRate=this.savedgrate;
    }
    else{
      this.purchaseItem.boardingRate=this.goldRate1;
    }
   
    console.log("purchaseItem.boardingRate",this.purchaseItem.boardingRate);
    console.log("goldRate1",this.goldRate1)
    if(this.taxType=='true'){
    this.billType=='GST'
    }

  },
  watch: {
    title() {
      this.getData();
    },
    billType(){
      console.log("billType==",this.billType)
    },
    datareload() {
      console.log("datareload==", this.datareload);
      if (this.datareload == true) {
        this.getData();
      }
    },
    itemPerWeight() {
      this.cal3();
    },
    customerName() {
      console.log("customerName==", this.customerName);
      if (!this.customerName) {
        this.stst1 = false;
      } else {
        this.stst1 = true;
      }
      console.log("tstt=====",this.stst1)
    },
    contact() {
      console.log("contact==", this.contact);
      if (!this.contact) {
        this.stst2 = false;
      } else {
        this.stst2 = true;
      }
    },
    saledata() {
      this.$emit("stepper", {
        ref: "customerData",
        saledata: this.saledata,
        check1: true,
      });
    },
    itempresent() {
      this.$emit("stepper", {
        ref: "itempresent",
        itempresent: this.itempresent,
      });
    },
  },
  methods: {
    maxValueRule(value) {
      if (value > 100) {
        return "Maximum value is 100";
      }
      return true;
    },
    maxValueRule2(item) {
      return (value) => {
        if (!value || value === "") return true;
        if (!this.purchaseItem.supplierCode) {
          return "Please select a supplier first";
        }
        var limit = item !== undefined && item !== null && item !== "" ? item : this.stockcount1;
        var maxLimit = parseFloat(limit);
        if (isNaN(maxLimit) || maxLimit <= 0) {
          return true;
        }
        if (parseFloat(value) > maxLimit) {
          return `Maximum count is ${maxLimit}`;
        }
        return true;
      };
    },
    maxValueRule3(item) {
      return (value) => {
        if (!value || value === "") return true;
        if (!this.purchaseItem.supplierCode) {
          return "Please select a supplier first";
        }
        var limit = item !== undefined && item !== null && item !== "" ? item : this.totNetWeight1;
        var maxLimit = parseFloat(limit);
        if (isNaN(maxLimit) || maxLimit <= 0) {
          return true;
        }
        if (parseFloat(value) > maxLimit) {
          return `Maximum value is ${maxLimit} gm`;
        }
        return true;
      };
    },
    maxValueRule4(item) {
      return (value) => {
        if (value > item) {
          return `Maximum value is ${item}`;
        }
        else if (value <= 0) {
          return `Minimum value is 1`;
        }
        return true;
      };
    },
    maxValueRule5(item) {
      if(item){
      return (value) => {
        if (value > item) {
          return `Maximum value is ${item}`;
        }
        return true;
      };
    }
    },
    customFilter (item, queryText) {
        const textOne = ((item && item.name) || "").toLowerCase();
        const textTwo = ((item && item.code) || "").toLowerCase();
        const textThree = ((item && item.description) || "").toLowerCase();
        const searchText = (queryText || "").toLowerCase();
        return textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1 || textThree.indexOf(searchText) > -1;
    },
    setDefault() {
      {
        this.$emit("stepper", {
          ref: "addedItem",
          items1: this.itemz,
          grate:this.purchaseItem.boardingRate,
          saledata: this.saledata,
          check: true,
        });
      }
    },
    validate() {
      console.log("333333")

      if (this.stst1 == false) {
        this.msg = "Please provide customer name";
        this.showsnackbar = true;
        return;
      } else if (this.stst2 == false) {
        this.msg = "Please enter contact";
        this.showsnackbar = true;
        return;
      }  else if (!this.purchaseItem.ItemCode) {
        this.msg = "Please choose item";
        this.showsnackbar = true;
        return;
      }else if (!this.purchaseItem.design) {
        this.msg = "Please choose design";
        this.showsnackbar = true;
        return;
      }  else if (!this.purchaseItem.supplierCode) {
        this.msg = "Please choose supplier";
        this.showsnackbar = true;
        return;
      } else if (this.purchaseItem.quantity>this.stockcount1) {
        console.log("stockcount1=",this.stockcount1)
        console.log("purchaseItem.quantity",this.purchaseItem.quantity)

        // if( this.purchaseItem.quantity>this.stockcount1){
          this.msg = "Please enter valid quantity1";
        this.showsnackbar = true;
        // }
        // if(this.purchaseItem.quantity<0 ){
        //   this.msg = "Please enter valid quantity2";
        // this.showsnackbar = true;
        // }
        // console.log("purchaseItem.quantity",this.purchaseItem.quantity)

      
        return;
      }
      else if (this.purchaseItem.quantity && this.purchaseItem.quantity > this.stockcount1) {
        this.msg = "Please enter valid quantity";
        this.showsnackbar = true;
        return;
      } 
      else if (this.purchaseItem.quantity && this.purchaseItem.quantity < 0) {
        this.msg = "Please enter valid quantity2";
        this.showsnackbar = true;
        return;
      } 
      else if (this.purchaseItem.va && this.purchaseItem.va > 100) {
        this.msg = "Please enter valid VA";
        this.showsnackbar = true;
        return;
      }else if (!this.purchaseItem.boardingRate || this.purchaseItem.boardingRate==0) {
        this.msg = "Boarding rate not found";
        this.showsnackbar = true;
        return;
      } else if (this.purchaseItem.netweight&&this.purchaseItem.netweight<0) {
        this.msg = "Please enter valid Net weight";
        this.showsnackbar = true;
        return;
      }else if (this.purchaseItem.netweight&&this.purchaseItem.netweight>this.totNetWeight1) {
        this.msg = "Please enter valid Net weight";
        this.showsnackbar = true;
        return;
      }else if (!this.purchaseItem.netweight || this.purchaseItem.netweight=='0') {
        this.msg = "Please enter Net weight";
        this.showsnackbar = true;
        return;
      } else if (this.purchaseItem.discount && this.purchaseItem.makingCharge && this.purchaseItem.discount >= this.purchaseItem.makingCharge) {
        this.msg = "Discount amount cannot be greater than making charge";
        this.showsnackbar = true;
        return;
      } 
      else {
        console.log("4444")
        this.addValues();
      }
    },
    addValues() {
      console.log("555544")

      this.singleitem.itemId = this.purchaseItem.ItemCode;
      this.singleitem.supplierId = this.purchaseItem.supplierCode;
      // this.singleitem.designId = this.purchaseItem.design._id.design._id;
      this.singleitem.designId = this.purchaseItem.design._id;

      this.singleitem.quantity = this.purchaseItem.quantity;
      this.singleitem.valueAddition = parseFloat(this.purchaseItem.va) || 0;
      this.singleitem.goldRate = this.purchaseItem.boardingRate;
      this.singleitem.makingCharge = parseFloat(this.purchaseItem.makingCharge) || 0;
      this.singleitem.metalType = this.newMetalType;
      this.singleitem.makingChargeType = this.newMakingChargeType || "Percentage";
      this.singleitem.netWeight = this.purchaseItem.netweight;
      this.singleitem.discountAmount = parseFloat(this.purchaseItem.discount) || 0;
      this.singleitem.itemTotalAmount = this.purchaseItem.itemTotalAmount;
      this.singleitem.adjustedMakingCharge = this.purchaseItem.newmakingcharge != null && this.purchaseItem.newmakingcharge !== "" ? parseFloat(this.purchaseItem.newmakingcharge) : (parseFloat(this.purchaseItem.makingCharge) || 0);
      this.singleitem.adjustedVA = this.purchaseItem.newVA != null && this.purchaseItem.newVA !== "" ? parseFloat(this.purchaseItem.newVA) : (parseFloat(this.purchaseItem.va) || 0);
      this.singleitem.purchaseId = this.purchaseItem.purchaseId;
      this.singleitem.purchaseitemId = this.purchaseItem.purchaseitemId;

      this.addVariant();
    },
    deleteStaff() {
      axios({
        url: "/saleitem/delete",
        method: "POST",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          id: this.curId,
        },
      })
        .then((response) => {
          this.dialoge = false;
          this.appLoading = false;
          if (response.data.status == true) {
            this.msg = response.data.msg;
            this.showsnackbar = true;
            this.dialoge = false;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    addVariant() {
      this.itemz.push(JSON.parse(JSON.stringify(this.singleitem)));
      console.log("itemz=", this.itemz);
      //////
      this.purchaseItem.ItemCode = null;
      this.purchaseItem.supplierCode = null;
      this.purchaseItem.design = null;
      this.purchaseItem.quantity = null;
      this.purchaseItem.va = null;
      this.purchaseItem.netweight = null;
      this.purchaseItem.makingCharge = null;
      this.purchaseItem.newmakingcharge = null;
      this.purchaseItem.discount = null;
      this.purchaseItem.newVA = null;
      this.purchaseItem.itemTotalAmount = null;
      this.purchaseItem.metalType = "Gold";
      this.purchaseItem.makingChargeType = "Percentage";
      this.stockCount="";
      this.setDefault();
      this.itemz = [];
    },
    changebillgst(){
this.billType="GST";
localStorage.setItem("billType",this.billType)
if(this.purchaseItem.itemTotalAmount)
this.cal2();
    },
    changebillnongst(){
this.billType="DEMO";
localStorage.setItem("billType",this.billType)
if(this.purchaseItem.itemTotalAmount)
this.cal2();
 
    },
    cal1() {
      if (this.newMetalType === "Silver" && this.newMakingChargeType === "Flat") {
        // Making charge is entered directly by the user in flat mode - nothing to compute.
        this.cal2();
        return;
      }
      var tst1 = (parseFloat(this.purchaseItem.boardingRate) || 0) * (parseFloat(this.purchaseItem.netweight) || 0);
      console.log("tst1",tst1);
      var vaVal = parseFloat(this.purchaseItem.va) || 0;
      var tst2 = vaVal / 100;
      console.log("tst2",tst2);

      this.purchaseItem.makingCharge = tst1 * tst2;
      console.log("this.purchaseItem.makingCharge",this.purchaseItem.makingCharge);

      this.cal2();
    },
    cal2() {
      console.log("cal2 called");
      var baseTotal = (parseFloat(this.purchaseItem.boardingRate) || 0) * (parseFloat(this.purchaseItem.netweight) || 0);
      var mc = parseFloat(this.purchaseItem.makingCharge) || 0;
      var disc = parseFloat(this.purchaseItem.discount) || 0;
      //if discount present
      if (disc > 0) {
        this.purchaseItem.newmakingcharge = Math.max(0, mc - disc);
        console.log("newmakingcharge=", this.purchaseItem.newmakingcharge);
        var onepercentoftotal = baseTotal * 0.01;
        this.purchaseItem.newVA = onepercentoftotal > 0 ? (this.purchaseItem.newmakingcharge / onepercentoftotal) : 0;
        console.log("newVA=", this.purchaseItem.newVA);
        this.total2 = baseTotal + this.purchaseItem.newmakingcharge;
        console.log("withdiscounttotal=", this.total2);
        // calculating total with gst
        if(this.gstpercent && this.billType=='GST'){
          console.log("discount-total==",this.total2)
          var newamt = this.total2*(this.gstpercent/100);
          console.log("newamt==",newamt)
          var newamt2 =newamt+this.total2;
          this.purchaseItem.itemTotalAmount = newamt2;
          console.log("discount-gst-total==",newamt2)
          this.purchaseItem.amountWithGst=newamt2;
        }
        else{
          this.purchaseItem.itemTotalAmount = this.total2;
        }
        this.purchaseItem.amountWithoutGst=this.total2;
      } else {
        //if no discount
        this.total1 = baseTotal + mc;
        console.log("withoutdiscounttotal=", this.total1);
         // calculating total with gst
         if(this.gstpercent && this.billType=='GST'){
          var newamt3 = this.total1*(this.gstpercent/100);
          var newamt4 =newamt3+this.total1;
          this.purchaseItem.itemTotalAmount = newamt4;
          console.log("nodiscount-gst-total==",newamt4)
          this.purchaseItem.amountWithGst=newamt4;
        }
        else{
          this.purchaseItem.itemTotalAmount = this.total1;
        }
        this.purchaseItem.amountWithoutGst=this.total1;
      }
      // this.addValues();
    },
    cal3() {
      if (this.purchaseItem.quantity) {
        // alert("1")
        this.purchaseItem.netweight =
          this.purchaseItem.quantity * this.itemPerWeight;
          console.log("itemPerWeight===",this.itemPerWeight)
          console.log("quantity===",this.purchaseItem.quantity)

          console.log("netwt===",this.purchaseItem.netweight)
          this.cal1();
      }
       else {
        this.purchaseItem.netweight="";
        // this.purchaseItem.netweight = this.itemPerWeight;
        // alert("2")
      }
    },
    caledit1() {
      // the line's stone weight covers all its pieces - scale it with the quantity
      var stone = (this.curitem.stonePerPiece || 0) * (parseFloat(this.curitem.quantity) || 0);
      this.curitem.stoneWeight = stone;
      this.curitem.netWeight=(this.curitem.quantity*this.curitem.itemPerWeight)-stone;
      console.log("curitem.netwt==",this.curitem.netWeight)
      this.editcal1();
    },
    editcal1() {
      if (this.curitem.metalType === "Silver" && this.curitem.makingChargeType === "Flat") {
        // Making charge is entered directly by the user in flat mode - nothing to compute.
        return;
      }
      var tst1 = (parseFloat(this.curitem.goldRate) || 0) * (parseFloat(this.curitem.netWeight) || 0);
      var tst2 = (parseFloat(this.curitem.valueAddition) || 0) / 100;
      this.curitem.makingCharge = tst1 * tst2;
      // this.editcal2();
    },
    editcal2() {
      if(this.curitem.netWeight>this.curitem.purchaseItemId.netWeight){
        this.msg = "Net weight cannot be greater than" + this.curitem.purchaseItemId.netWeight;
        this.showsnackbar = true;
        return;
      }
      if(this.curitem.netWeight<=0){
        this.msg = "Invalid Net weight";
        this.showsnackbar = true;
        return;
      }
      var curMc = parseFloat(this.curitem.makingCharge) || 0;
      var curDisc = parseFloat(this.curitem.discountAmount) || 0;
      if(curDisc > 0 && curMc > 0 && curDisc >= curMc){
        this.msg = "Invalid Discount Amt";
        this.showsnackbar = true;
        return;
      }
      else{
      console.log("curitem.discount==", this.curitem.discountAmount);
      var baseAmt = (parseFloat(this.curitem.goldRate) || 0) * (parseFloat(this.curitem.netWeight) || 0);
      if (curDisc > 0) {
        //if discountAmount present
        this.curitem.adjustedMakingCharge = Math.max(0, curMc - curDisc);
        console.log("newmakingcharge=", this.curitem.adjustedMakingCharge);
        var onepercentoftotal = baseAmt * 0.01;
        this.curitem.adjustedVA = onepercentoftotal > 0 ? (this.curitem.adjustedMakingCharge / onepercentoftotal) : 0;
        console.log("newVA=", this.curitem.adjustedVA);
        this.total3 = baseAmt + this.curitem.adjustedMakingCharge;
        console.log("withdiscounttotal2=", this.total3);
        this.curitem.itemTotalAmount = this.total3;
      } else {
        //if no discount
        var total1 = baseAmt + curMc;
        console.log("withoutdiscounttotal3=", total1);
        this.curitem.itemTotalAmount = total1;
      }
      this.editItem();
    }
    },
    checkQty() {
      this.purchaseItem.quantity="";
      // this.appLoading = true;
      axios({
        method: "POST",
        url: "/itemcount",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          jewelleryId: this.juwellaryId,
          // designId: this.purchaseItem.design._id.design._id,
          designId: this.purchaseItem.design._id,

          itemId: this.purchaseItem.ItemCode,
          supplierId: this.purchaseItem.supplierCode,
        },
      })
        .then((response) => {
          // this.appLoading = false;
          if (response.data.status == true) {
            this.stockWt = response.data.totNetWeight;
            // var stockcount1 = response.data.data[0].newquantity;
            var stockcount1 = response.data.quantity;
            this.stockcount1  = response.data.quantity;
            console.log("stockcount1",stockcount1)
            this.stockCount =
              "Available count : " + JSON.stringify(stockcount1);
            console.log("stockCountprint=",this.stockCount)
            // this.itemPerWeight = response.data.itemPerWeight;
            // var totNetWeight1 = response.data.data[0].newnetwieght;
            this.totNetWeight1 = response.data.netWeight;

            this.totNetWeight =
              "Available weight : " + JSON.stringify(this.totNetWeight1)+ "gm";
            console.log("totNetWeight ", this.totNetWeight);
            this.Pagelength = Math.ceil(response.data.count / 20);
          } else {
            this.snackbar = true;
            this.msg = response.data.msg;
          } 

          // this.msg = response.data.msg;

          // this.snackbar = true;
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    // Bulk lots are stored with itemPerWeight forced to 0 (no per-piece weight,
    // only a lot total) -- show the available lot weight instead of "0gm".
    designOptionLabel(option) {
      var name = option._id.design.name;
      if (option._id.isBulk) {
        var wt = Number(option.totalNetWeight || 0).toFixed(2);
        return name + " - Bulk (" + wt + "gm)";
      }
      return name + " - " + option._id.itemPerWeight + "gm";
    },
    checktype(item) {
      console.log("item choosed=", item);
      var singleobj = this.designList.find((x) => x._id.id == item.id);
      console.log("singleobj==", singleobj);

      // countOrSplit is now part of the group key itself (each purchase lot's
      // own choice), not just the design's default -- read it from there.
      console.log("singleobj.countOrSplit==", singleobj._id.countOrSplit);
      if (singleobj._id.countOrSplit == "Count") {
        this.dtype = true;
        console.log("dtype=", this.dtype);
      } else {
        this.dtype = false;
        console.log("dtype=", this.dtype);
      }
      this.itemPerWeight=singleobj._id.itemPerWeight;
      console.log("itemPerWeight====",this.itemPerWeight)
    },
    calNetWt() {
      this.purchaseItem.netweight =
        this.selectedItemWt * this.purchaseItem.quantity;
    },
    getData() {
      axios({
        url: "/sales/getlist",
        method: "get",
        params: {
          billNo: this.title,
          status: "Pending",
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.List = response.data.data;
            this.savedgrate= response.data.saledata.goldRate;
            this.purchaseItem.boardingRate = this.savedgrate;
            if(this.List){
              if (this.List.length > 0) {
                this.itempresent = true;
                console.log("qq1")
              } else {
                this.itempresent = false;
                console.log("qq2")
              }
            }
            else{
              this.itempresent = false;
                console.log("qq2")
            }
            // this.saleId = response.data.saledata._id;
            this.saledata = response.data.saledata;
          } else {
            this.msg = response.data.msg;
            // this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getItem() {
      axios({
        method: "POST",
        url: "/item/getlist/purchased",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          jewelleryId: this.juwellaryId,
          page: this.page,
          count: 20,
        },
      })
        .then((response) => {
          // this.appLoading = false;
          if (response.data.status == true) {
            this.ItemList = response.data.allitemlist;
            this.Pagelength = Math.ceil(response.data.count / 20);
          } else {
            this.snackbar = true;
            this.msg = response.data.msg;
          }

          // this.msg = response.data.msg;

          // this.snackbar = true;
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    getSupplier() {
      // this.appLoading = true;
      // this.purchaseItem.design=null;
      this.SupplierList = [];
      this.purchaseItem.supplierCode = "";
      this.totNetWeight1 = "";
      this.totNetWeight = "";
      this.stockcount1 = "";
      this.stockCount = "";
      // this.purchaseItem.purchaseId=null;
      this.purchaseItem.quantity = "";
      // this.purchaseItem.va=0;
      // this.purchaseItem.netweight=0;
      // this.purchaseItem.makingCharge=0;
      // this.purchaseItem.discount=0;
      axios({
        method: "Post",
        url: "/supplier/getlist/purchased",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          jewelleryId: this.juwellaryId,
          designId: this.purchaseItem.design._id,
          itemId: this.purchaseItem.ItemCode,
        },
      })
        .then((response) => {
          // this.appLoading = false;
          if (response.data.status == true) {
            this.SupplierList = response.data.supplierlist;
            this.gstpercent = response.data.gst;
            console.log("gstpercent=", this.gstpercent);

            this.Pagelength = Math.ceil(response.data.count / 20);
            if (this.SupplierList && this.SupplierList.length === 1) {
              this.purchaseItem.supplierCode = this.SupplierList[0]._id;
              this.checkQty();
              this.getPurchase();
            }
          } else {
            this.snackbar = true;
            this.msg = response.data.msg;
          }

          // this.msg = response.data.msg;

          // this.snackbar = true;
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    getDesign() {
      this.designList = [];
      this.purchaseItem.quantity = "";
      this.purchaseItem.supplierCode = "";
      this.purchaseItem.design = "";
      this.totNetWeight1 = "";
      this.totNetWeight = "";
      this.stockcount1 = "";
      this.stockCount = "";

      // this.appLoading = true;
      axios({
        method: "POST",
        url: "/design/getlist/purchased",
        // url: "/stock/getalllist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          jewelleryId: this.juwellaryId,
          itemId: this.purchaseItem.ItemCode,
        },
      })
        .then((response) => {
          // this.appLoading = false;
          if (response.data.status == true) {
            this.designList = response.data.data;
            this.Pagelength = Math.ceil(response.data.count / 20);
          } else {
            this.snackbar = true;
            this.msg = response.data.msg;
          }

          // this.msg = response.data.msg;

          // this.snackbar = true;
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    // getDesign2() {
    //   // this.appLoading = true;
    //   axios({
    //     method: "POST",
    //     url: "/design/getlist/purchased",
    //     headers: {
    //       "x-auth-token": localStorage.getItem("token"),
    //     },
    //     data: {
    //       jewelleryId: this.juwellaryId,
    //       itemId: this.curitem.itemId,
    //     },
    //   })
    //     .then((response) => {
    //       // this.appLoading = false;
    //       if (response.data.status == true) {
    //         this.designList2 = response.data.alldesignlist;
    //         this.Pagelength = Math.ceil(response.data.count / 20);
    //       } else {
    //         this.snackbar = true;
    //         this.msg = response.data.msg;
    //       }

    //       // this.msg = response.data.msg;

    //       // this.snackbar = true;
    //     })
    //     .catch((err) => {
    //       this.appLoading = false;
    //       console.log(err);
    //     });
    // },
    getPurchase() {
      // this.appLoading = true;
      axios({
        method: "POST",
        url: "/billnumber/getlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          jewelleryId: this.juwellaryId,
          itemId: this.purchaseItem.ItemCode,
          designId: this.purchaseItem.design._id.design._id,
          supplierId: this.purchaseItem.supplierCode,
        },
      })
        .then((response) => {
          // this.appLoading = false;
          if (response.data.status == true) {
            this.purchaseList = response.data.data;
            this.Pagelength = Math.ceil(response.data.count / 20);
          } else {
            this.snackbar = true;
            this.msg = response.data.msg;
          }

          // this.msg = response.data.msg;

          // this.snackbar = true;
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    getWeight() {
      axios({
        method: "POST",
        url: "/billbased/items/",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          jewelleryId: this.juwellaryId,
          page: this.page,
          count: 20,
          purchaseId: this.purchaseItem.purchaseId,
        },
      })
        .then((response) => {
          // this.appLoading = false;
          if (response.data.status == true) {
            this.weightList = response.data.allpurchaseitems;
            this.Pagelength = Math.ceil(response.data.count / 20);
          } else {
            this.snackbar = true;
            this.msg = response.data.msg;
          }

          // this.msg = response.data.msg;

          // this.snackbar = true;
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    editItem() {
      this.itemz2.push(JSON.parse(JSON.stringify(this.curitem)));
      console.log("itemz=", this.itemz);
      axios({
        url: "/sales/edit",
        method: "POST",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          id: this.curitem._id,
          items: this.itemz2,
        },
      })
        .then((response) => {
          this.editdialogue = false;
          this.appLoading = false;
          if (response.data.status == true) {
            this.msg = response.data.msg;
            this.showsnackbar = true;
            this.itemz2 = [];
            this.curitem = {};
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>
<style scoped>
.es-add-item-container {
  color: #1e293b;
}

.estimate-item-card {
  background: #ffffff !important;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04) !important;
}

.card-top-bar {
  background: #fafafa;
}

.card-heading {
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: #0f172a;
}

.item-selection-grid {
  display: grid;
  grid-template-columns: minmax(180px, 1.2fr) minmax(180px, 1.2fr) minmax(220px, 1.6fr) minmax(110px, 0.7fr);
  gap: 14px;
  align-items: flex-start;
}

.grid-item-supplier-wide {
  grid-column: span 2;
}

.item-calculation-grid {
  display: grid;
  grid-template-columns: minmax(100px, 0.9fr) minmax(95px, 0.8fr) minmax(130px, 1.2fr) minmax(120px, 1.1fr) minmax(130px, 1.2fr) minmax(110px, 1fr) minmax(120px, 1.1fr) 46px;
  gap: 12px;
  align-items: flex-start;
}

.item-calculation-grid.has-charge-type {
  grid-template-columns: minmax(90px, 0.8fr) minmax(110px, 0.9fr) minmax(85px, 0.7fr) minmax(115px, 1fr) minmax(115px, 1fr) minmax(115px, 1fr) minmax(95px, 0.8fr) minmax(110px, 1fr) 46px;
}

.grid-item {
  display: flex;
  flex-direction: column;
}

.grid-action-item {
  display: flex;
  flex-direction: column;
}

.action-label-placeholder {
  visibility: hidden;
  user-select: none;
  pointer-events: none;
}

.erp-field-label {
  display: block;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #64748b;
  margin-bottom: 5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.required-star {
  color: #dc2626;
}

.erp-field >>> .v-input__slot {
  border-radius: 8px !important;
  font-size: 13.5px;
}

.erp-readonly >>> .v-input__slot {
  background-color: #f8fafc !important;
}

.erp-field >>> .v-text-field__details {
  padding-left: 2px !important;
  padding-right: 2px !important;
  margin-top: 3px !important;
  min-height: 16px !important;
}

.erp-field >>> .v-messages__message {
  font-size: 11px !important;
  font-weight: 500 !important;
  color: #64748b !important;
  line-height: 1.2 !important;
}

.selected-text {
  font-size: 13.5px;
  color: #0f172a;
  font-weight: 500;
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}

.erp-add-item-btn {
  background: linear-gradient(135deg, #b9893f 0%, #875c24 100%) !important;
  background-color: #9a6b27 !important;
  color: #ffffff !important;
  height: 40px !important;
  min-width: 46px !important;
  width: 46px !important;
  border-radius: 10px !important;
  transition: all 0.25s ease !important;
  box-shadow: 0 4px 14px rgba(154, 106, 44, 0.28) !important;
}

.erp-add-item-btn:hover {
  background: linear-gradient(135deg, #c59449 0%, #956627 100%) !important;
  box-shadow: 0 6px 18px rgba(154, 106, 44, 0.38) !important;
  transform: translateY(-1.5px) !important;
}

/* Items Table */
.erp-table-card {
  border: 1px solid #e2e8f0;
}

.erp-item-table thead {
  background-color: #f8fafc;
}

.erp-item-table thead th {
  font-size: 11px !important;
  font-weight: 700 !important;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #475569 !important;
  border-bottom: 1px solid #e2e8f0 !important;
}

.erp-item-table tbody td {
  font-size: 12.5px !important;
  color: #1e293b;
  border-bottom: 1px solid #f1f5f9 !important;
}

.table-row-hover:hover {
  background-color: #f8fafc;
}

.table-summary-bar {
  background-color: #f8fafc;
  border-top: 1px solid #e2e8f0;
}

.summary-pill {
  display: inline-flex;
  align-items: center;
  padding: 6px 14px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 13px;
}

.pill-label {
  color: #64748b;
  margin-right: 6px;
}

.pill-val {
  color: #0f172a;
}

.highlight-pill {
  border-color: #fcd34d;
  background-color: #fffbeb;
}

.highlight-pill .pill-val {
  color: #b45309;
}

/* Modals */
.erp-modal-card {
  background: #ffffff !important;
}

.modal-top-bar {
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
}

.modal-title {
  font-size: 15px;
  font-weight: 700;
  color: #0f172a;
}

.modal-subtext {
  font-size: 12px;
  color: #64748b;
}

.bg-modal-footer {
  background-color: #f8fafc;
  border-top: 1px solid #e2e8f0;
}

.erp-action-btn {
  background: linear-gradient(135deg, #b9893f 0%, #875c24 100%) !important;
  background-color: #9a6b27 !important;
  color: #ffffff !important;
  font-weight: 600 !important;
  border-radius: 10px !important;
  box-shadow: 0 4px 14px rgba(154, 106, 44, 0.28) !important;
  transition: all 0.25s ease !important;
}

.erp-action-btn:hover {
  background: linear-gradient(135deg, #c59449 0%, #956627 100%) !important;
  box-shadow: 0 6px 18px rgba(154, 106, 44, 0.38) !important;
  transform: translateY(-1.5px) !important;
}

@media (max-width: 1200px) {
  .item-selection-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .grid-item-supplier-wide {
    grid-column: span 1;
  }
  .item-calculation-grid,
  .item-calculation-grid.has-charge-type {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .grid-action-item {
    grid-column: span 4;
    flex-direction: row;
    justify-content: flex-end;
  }
  .grid-action-item .action-label-placeholder {
    display: none;
  }
}

@media (max-width: 600px) {
  .item-selection-grid,
  .item-calculation-grid,
  .item-calculation-grid.has-charge-type {
    grid-template-columns: 1fr;
  }
  .grid-action-item {
    grid-column: span 1;
    justify-content: flex-end;
  }
}
</style>